import { DEFAULT_SECTIONS, ProductTypeConfig } from '../types';

/**
 * 1260 - Bonus Certificate (Conditional Coupon)
 * Autocall variant
 *
 * Same as 1230 but with conditional coupon (coupon barrier + coupon memory)
 * Shows: barrier info, strike levels, barrier levels, early redemption with levels
 * Additional: Coupon Barrier, Coupon Memory, Distance from coupon barrier
 */
export const config1260Autocall: ProductTypeConfig = {
  code: '1260',
  callableType: 'Autocall',
  name: 'Bonus Certificate',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: true,
        couponBarrier: true, // Show Coupon Barrier
        couponMemory: true, // Show Coupon Memory: Yes/No
        upside: false,
        upsideParticipation: false,
        cap: false,
        distanceToCap: false,
        issuePricePct: false,
        issuePrice: false,
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
      props: {
        barrierType: true,
        strikeLevel: true,
        strikeDistance: true,
        barrierLevel: true,
        barrierDistance: true,
        barrierHit: true,
        couponBarrier: true,
        couponMemory: true,
        distanceCouponBarrier: true,
        stopLoss: false,
        distanceStopLoss: false,
      },
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        barrierLevel: true,
        barrierDistance: true,
        autocallDistance: true,
        distanceCouponBarrier: true,
      },
    },

    coupons: {
      enabled: true,
      props: {},
    },

    earlyRedemption: {
      ...DEFAULT_SECTIONS.earlyRedemption,
      enabled: true,
      props: {
        observationDate: true,
        redemptionLevel: true,
        showIssuerCallable: false,
      },
    },

    performance: {
      enabled: true,
      props: {},
    },
  },
};

/**
 * 1260 - Bonus Certificate (Conditional Coupon)
 * Callable variant
 *
 * Same as 1230 Callable but with conditional coupon
 */
export const config1260Callable: ProductTypeConfig = {
  code: '1260',
  callableType: 'Callable',
  name: 'Bonus Certificate',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: true,
        couponBarrier: true,
        couponMemory: true,
        upside: false,
        upsideParticipation: false,
        cap: false,
        distanceToCap: false,
        issuePricePct: false,
        issuePrice: false,
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
      props: {
        barrierType: true,
        strikeLevel: true,
        strikeDistance: true,
        barrierLevel: true,
        barrierDistance: true,
        barrierHit: true,
        couponBarrier: true,
        couponMemory: true,
        distanceCouponBarrier: true,
        stopLoss: false,
        distanceStopLoss: false,
      },
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        barrierLevel: true,
        barrierDistance: true,
        distanceCouponBarrier: true,
      },
    },

    coupons: {
      enabled: true,
      props: {},
    },

    earlyRedemption: {
      ...DEFAULT_SECTIONS.earlyRedemption,
      enabled: true,
      props: {
        observationDate: true,
        redemptionLevel: false,
        showIssuerCallable: true,
      },
    },

    performance: {
      enabled: true,
      props: {},
    },
  },
};

/**
 * 1260 - Bonus Certificate (Conditional Coupon)
 * Standard variant (non-callable)
 *
 * Same as 1230 Standard but with conditional coupon
 */
export const config1260Standard: ProductTypeConfig = {
  code: '1260',
  callableType: 'Standard',
  name: 'Bonus Certificate',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: true,
        couponBarrier: true,
        couponMemory: true,
        upside: false,
        upsideParticipation: false,
        cap: false,
        distanceToCap: false,
        issuePricePct: false,
        issuePrice: false,
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
      props: {
        barrierType: true,
        strikeLevel: true,
        strikeDistance: true,
        barrierLevel: true,
        barrierDistance: true,
        barrierHit: true,
        couponBarrier: true,
        couponMemory: true,
        distanceCouponBarrier: true,
        stopLoss: false,
        distanceStopLoss: false,
      },
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        barrierLevel: true,
        barrierDistance: true,
        distanceCouponBarrier: true,
      },
    },

    coupons: {
      enabled: true,
      props: {},
    },

    earlyRedemption: {
      enabled: false,
      props: {},
    },

    performance: {
      enabled: true,
      props: {},
    },
  },
};


export const config1260Express: ProductTypeConfig = {
  code: '1260',
  callableType: 'Express',
  name: 'Express Certificate',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: true,
        couponBarrier: true, // Show Coupon Barrier
        couponMemory: true, // Show Coupon Memory: Yes/No
        upside: false,
        upsideParticipation: false,
        cap: false,
        distanceToCap: false,
        issuePricePct: false,
        issuePrice: false,
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
      props: {
        barrierType: true,
        strikeLevel: true,
        strikeDistance: true,
        barrierLevel: true,
        barrierDistance: true,
        barrierHit: true,
        couponBarrier: true,
        couponMemory: true,
        distanceCouponBarrier: true,
        stopLoss: false,
        distanceStopLoss: false,
      },
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        barrierLevel: true,
        barrierDistance: true,
        autocallDistance: true,
        distanceCouponBarrier: true,
      },
    },

    coupons: {
      enabled: true,
      props: {},
    },

    earlyRedemption: {
      ...DEFAULT_SECTIONS.earlyRedemption,
      enabled: true,
      props: {
        observationDate: true,
        redemptionLevel: true,
        showIssuerCallable: false,
      },
    },

    performance: {
      enabled: true,
      props: {},
    },
  },
};
